<template>
  <div>
    <v-btn fab bottom right color="accent" fixed @click.stop="dialog = !dialog">
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" scrollable width="800px">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text"> Create New Voucher </v-card-title>
        <v-card-text>
          <v-form v-model="FormVoucher.valid" enctype="multipart/form-data">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout row wrap>
                <v-flex xs12 align-center justify-space-between>
                  <v-text-field
                    type="number"
                    min="1"
                    label="Amount"
                    v-validate="'numeric|min_value:1|required'"
                    :error-messages="errors.collect('amount')"
                    data-vv-name="amount"
                    v-model="FormVoucher.unit_value"
                    prefix="฿"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    type="number"
                    min="1"
                    label="Quantity"
                    v-validate="'numeric|min_value:1|required'"
                    :error-messages="errors.collect('quantity')"
                    data-vv-name="quantity"
                    v-model="FormVoucher.quantity"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md5>
                  <v-menu
                    ref="menuDate"
                    :close-on-content-click="false"
                    v-model="menuDate"
                    :nudge-right="40"
                    :return-value.sync="FormVoucher.date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        prepend-inner-icon="event"
                        v-model="computedDateFormatted"
                        label="Expire Date"
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :min="min"
                      color="primary"
                      v-model="FormVoucher.date"
                      scrollable
                      @change="$refs.menuDate.save(FormVoucher.date)"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <v-text-field
                    slot="activator"
                    disabled
                    v-model="FormVoucher.time"
                    label="Time"
                    prepend-inner-icon="access_time"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group
                    label="Voucher type"
                    auto-grow
                    color="primary"
                    mandatory
                    row
                    v-model="FormVoucher.type"
                  >
                    <v-radio label="Buy" value="buy"></v-radio>
                    <v-radio label="Refund" value="refund"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Note"
                    v-model="FormVoucher.note"
                    auto-grow
                    color="primary"
                    rows="5"
                    counter
                    clearable
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <Upload preview label="Select Receipt" v-model="FormVoucher.transfer_receipt"></Upload>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-3 pr-5">
          <!-- <v-btn text color="primary">More</v-btn> -->
          <v-spacer></v-spacer>
          <v-btn text @click="(dialog = false), resetFormError(null, FormVoucher)">Cancel</v-btn>
          <v-btn color="primary" text :disabled="!FormVoucher.valid" @click="confirmToCreate">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Form from '../form/form';
import formMixin from '../Mixins/form';
import loader from '../utils/loader';
import moment from 'moment';
import voucherService from '../services/voucher';
import dateUtil from '../utils/dateTime';
import voucherTransformer from '../transformers/voucher';

export default {
  mixins: [formMixin],
  provide() {
    return { parentValidator: this.$validator };
  },
  data() {
    const minDate = moment().add(1, 'week').format('YYYY-MM-DD');
    return {
      dialog: false,
      menuDate: false,
      menuTime: false,
      min: minDate,
      FormVoucher: new Form({
        data: () => ({
          note: '',
          unit_value: 100,
          quantity: 1,
          date: minDate,
          time: '23:59:59',
          transfer_receipt: null,
          type: 'refund',
        }),
        transformToPayload: voucherTransformer.convertExpireDateTime,
      }),
    };
  },
  computed: {
    currentText() {
      if (this.text) return this.text;
      else return 'Processing';
    },
    computedDateFormatted() {
      return this.formatDate(this.FormVoucher.date);
    },
  },
  methods: {
    formatDate(date) {
      // console.log(date)
      if (!date) return null;
      const dateMoment = dateUtil.formatDate(date);
      return dateMoment;
    },
    confirmToCreate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm('Create', 'Are you confirm to create?', {
              color: 'primary',
              submitText: 'Yes',
            })
            .then((confirm) => {
              if (confirm) this.createVoucher();
            });
        }
      });
    },
    createVoucher() {
      const formData = new FormData();
      const formForPayload = this.FormVoucher.payload;

      if (formForPayload.transfer_receipt) {
        formData.append('transfer_receipt', formForPayload.transfer_receipt);
      }

      formData.append('note', formForPayload.note);
      formData.append('amount', formForPayload.unit_value);
      formData.append('quantity', formForPayload.quantity);
      formData.append('expiration', formForPayload.expire);
      formData.append('type', formForPayload.type);

      voucherService
        .create(formData)
        .then(() => {
          // success callback
          this.dialog = false;
          this.resetFormError(null, this.FormVoucher);
          this.$emit('success');
          this.$notify({
            title: 'Success',
            text: 'Voucher are created!!',
            type: 'success',
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {},
  components: {
    Upload: loader.component('UploadFile'),
  },
};
</script>
